import MenuItemImage from './MenuItemImage'

export default MenuItemImage
